import axios from 'axios'

const state = {
  loading: false,
  data: {
    service_id: '',
    user_price: '',
    form_data: {},
  },
}

const getters = {
  data(state) {
    return state.data
  },
}

const mutations = {
  setData(state, data) {
    state.data.service_id = data.id ? data.id : ''
    state.data.user_price = data.user_price ? data.user_price : ''
    state.data.form_data = data.form_data ? data.form_data : {}
  },
  setDataInit(state, data) {
    state.data.service_id = data.id ? data.id : ''
    state.data.user_price = data.user_price ? data.user_price : ''
  },
  setUserPrice(state, data) {
    state.data.user_price = data ? data : ''
  },
  emptyFields(state, data) {
    state.data.form_data = {}
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
